import { Link } from "react-router-dom";
import { fileUrl, formatBRL } from "@/lib/api";

export default function ProductCard({ product, index = 0 }) {
  const primary =
    (product.images || []).find((i) => i.is_primary) ||
    (product.images || [])[0];
  const second = (product.images || []).find((i) => i.path !== primary?.path);
  const hasSale = product.sale_price && product.sale_price > 0 && product.sale_price < product.price;
  const price = hasSale ? product.sale_price : product.price;
  const discount = hasSale ? Math.round((1 - product.sale_price / product.price) * 100) : 0;

  return (
    <Link
      to={`/produto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#0A0A0C] border border-white/5">
        {primary ? (
          <>
            <img
              src={fileUrl(primary.path)}
              alt={product.name}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            {second && (
              <img
                src={fileUrl(second.path)}
                alt={`${product.name} alternativa`}
                className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
              />
            )}
          </>
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-zinc-900 to-zinc-950 grid place-items-center">
            <span className="font-display text-5xl text-white/10 tracking-tighter">AM</span>
          </div>
        )}
        {hasSale && (
          <span className="absolute top-3 left-3 bg-white text-black text-[11px] font-semibold px-2 py-1 tracking-wide">
            -{discount}%
          </span>
        )}
        {product.new_arrival && !hasSale && (
          <span className="absolute top-3 left-3 bg-black/70 text-white text-[11px] font-semibold px-2 py-1 tracking-widest border border-white/20">
            NOVO
          </span>
        )}
      </div>
      <div className="pt-4 pb-2">
        <h3 className="text-white font-medium text-sm truncate">{product.name}</h3>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-white font-display text-base">{formatBRL(price)}</span>
          {hasSale && <span className="strike-price text-xs">{formatBRL(product.price)}</span>}
        </div>
        {(product.sizes?.length || 0) > 0 && (
          <div className="flex gap-2 mt-2 text-[11px] text-zinc-500">
            {product.sizes.slice(0, 5).join(" · ")}
          </div>
        )}
      </div>
    </Link>
  );
}
